import React, { useState, useEffect } from 'react';
import {
	Box,
	HStack,
	Text,
	Table,
	Thead,
	Tbody,
	Tr,
	Th,
	Td,
	TableContainer,
	useDisclosure,
	Spinner,
	Switch,
	Card,
	Center,
	Input,
	InputGroup,
	InputLeftElement,
	Flex,
	IconButton,
	useToast,
	Tag,
	CardBody
} from '@chakra-ui/react';
import { EditIcon, SearchIcon } from '@chakra-ui/icons';
import CustomModal from '../../components/CustomModal';
import CustomModalLink from '../../components/CustomModalLink';
import Create from './Create';
import Edit from './Edit';
import ChangePass from './change-password';
import { fetchWrapper } from '../../helpers';
import { useLocation } from 'react-router-dom';
import API from '../../helpers/axiosInstance';
import { getApiHeaders, hasPermission } from '../../utils/DefaultFunction';
import BoxWrapper from '../../components/BoxWrapper/BoxWrapper';

function List({ customer_id }) {
	const [loading, setLoading] = useState(false);
	const [searchQuery, setSearchQuery] = useState('');
	const { isOpen, onOpen, onClose } = useDisclosure();
	const { onOpen: onOpenEdit, onClose: onCloseEdit } = useDisclosure();
	const [isOpenEdit, setIsOpenEdit] = useState(false);
	const [modalEditView, setModalEditView] = useState(false);
	const [list, setList] = useState([]);
	const [modalHeader, setmodelHeader] = useState('');
	const location = useLocation();
	const [permissions, setPermissions] = useState([]);
	const [globalRequire2FA, setGlobalRequire2FA] = useState(false);
	const toast = useToast();

	const params = location.pathname.replace('/', '');

	const fetchPermissions = async () => {
		try {
			const url = `${process.env.REACT_APP_API_URL}/permission/feature/list?slug=${params}`;
			const response = await API.get(url, { headers: getApiHeaders() });
			setPermissions(response.data.data || []);
		} catch (error) {
			console.error('Error fetching permissions:', error);
			setPermissions([]);
		}
	};

	useEffect(() => {
		fetchPermissions();
		loadList();
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const listPermission = hasPermission('user-list', permissions);
	const createPermission = hasPermission('user-create', permissions);
	const editPermission = hasPermission('user-edit', permissions);
	const changePassPermission = hasPermission('user-change-password', permissions);
	const StatusPermission = hasPermission('user-update-status', permissions);

	const meClose = () => {
		onClose();
	};

	const loadList = async () => {
		setLoading(true);
		const url = `${process.env.REACT_APP_API_URL}/user/list`;
		const data = await fetchWrapper.get(url);

		setGlobalRequire2FA(data?.require_2fa_all || false);
		setList(data.data);
		setLoading(false);
	};

	const handleGlobal2FAToggle = async (newValue) => {
		try {
			const url = `${process.env.REACT_APP_API_URL}/customer-portal/2fa/require-all`;
			await fetchWrapper.post(url, { required: newValue });

			setGlobalRequire2FA(newValue);
			loadList();
			toast({
				title: 'Global 2FA Setting Updated',
				description: `2FA is now ${newValue ? 'required' : 'optional'} for all new users`,
				status: 'success',
				duration: 3000,
				isClosable: true,
			});
		} catch (error) {
			toast({
				title: 'Error',
				description: 'Failed to update global 2FA setting',
				status: 'error',
				duration: 3000,
				isClosable: true,
			});
			console.error('Error updating global 2FA setting:', error);
		}
	};

	const meEdit = (rs) => {
		setIsOpenEdit(true);
		setmodelHeader('Update User');
		setModalEditView(<Edit meCloseEdit={meCloseEdit} rs={rs} loadList={loadList} />);
	};

	const meChangePass = (rs) => {
		setIsOpenEdit(true);
		setmodelHeader('Change Password');
		setModalEditView(<ChangePass meCloseEdit={meCloseEdit} rs={rs} loadList={loadList} />);
	};

	const meCloseEdit = () => {
		setIsOpenEdit(false);
	};

	const [loadingStates, setLoadingStates] = useState({});

	const ChangeStatus = async (rs) => {
		setLoadingStates(prev => ({ ...prev, [`status_${rs.id}`]: true }));
		const data = {
			status_id: rs.status_id ? 0 : 1,
			id: rs.id,
		};
		const url = `${process.env.REACT_APP_API_URL}/user/update-status`;
		await fetchWrapper.post(url, data);
		await loadList();
		setLoadingStates(prev => ({ ...prev, [`status_${rs.id}`]: false }));
	};

	const handleTogglesuperAdmin = async (rs) => {
		setLoadingStates(prev => ({ ...prev, [`superadmin_${rs.id}`]: true }));
		const data = {
			super_admin: rs.super_admin ? 0 : 1,
			id: rs.id,
		};
		const url = `${process.env.REACT_APP_API_URL}/user/update-super-admin`;
		await fetchWrapper.post(url, data);
		await loadList();
		setLoadingStates(prev => ({ ...prev, [`superadmin_${rs.id}`]: false }));
	};

	const handleAccountAlertToggle = async (rs) => {
		setLoadingStates(prev => ({ ...prev, [`accountalert_${rs.id}`]: true }));
		const url = `${process.env.REACT_APP_API_URL}/user/update-status`;
		const customer = JSON.parse(localStorage.getItem('customer') || '{}');
		const data = {
			id: rs.id,
			account_alert: !rs.account_alert,
			customer_id: customer?.customer_id || 0,
		};
		await fetchWrapper.post(url, data);
		await loadList();
		setLoadingStates(prev => ({ ...prev, [`accountalert_${rs.id}`]: false }));
	};

	const handleToggle2FARequired = async (user) => {
		setLoadingStates(prev => ({ ...prev, [`2fa_${user.id}`]: true }));
		try {
			const newRequiredStatus = !user.twofa_required;
			const url = `${process.env.REACT_APP_API_URL}/user/2fa/require`;

			await fetchWrapper.post(url, {
				id: user.id,
				required: newRequiredStatus
			});

			toast({
				title: '2FA requirement updated',
				description: `2FA is now ${newRequiredStatus ? 'required' : 'optional'} for this user`,
				status: 'success',
				duration: 3000,
				isClosable: true,
			});

			await loadList();
		} catch (error) {
			toast({
				title: 'Error',
				description: 'Failed to update 2FA requirement',
				status: 'error',
				duration: 3000,
				isClosable: true,
			});
			console.error('Error updating 2FA requirement:', error);
		} finally {
			setLoadingStates(prev => ({ ...prev, [`2fa_${user.id}`]: false }));
		}
	};

	const getRoleName = (roleId) => {
		switch (roleId) {
			case 1:
				return 'Admin';
			case 2:
				return 'Manager';
			case 3:
				return 'User';
			default:
				return 'User';
		}
	};

	const filteredUsers = list.filter(
		(user) =>
			user.username?.toLowerCase().includes(searchQuery.toLowerCase()) ||
			user.email?.toLowerCase().includes(searchQuery.toLowerCase())
	);

	return (
		<>
			<BoxWrapper>
				{/* Header */}
				<Box mb={6}>
					<Text fontSize="2xl" fontWeight="normal" color="black">
						User Management
					</Text>
					<Text fontSize="sm" color="gray.600">
						Manage user accounts, permissions, and two-factor authentication
					</Text>
				</Box>

				{/* Global Security Settings Card */}
				<Card
					bg="white"
					shadow="sm"
					borderRadius="lg"
					border="1px solid"
					borderColor="gray.200"
					mb={6}
				>
					<Box px={6} py={4}>
						<Text fontSize="lg" fontWeight="medium">
							Global Security Settings
						</Text>
						<Text fontSize="sm" color="gray.600">
							Configure global two-factor authentication requirements
						</Text>
					</Box>
					<CardBody px={6} py={4}>
						<Flex justify="space-between" align="center">
							<Box>
								<Text fontSize="sm" fontWeight="medium">
									Require 2FA for New Users
								</Text>
								<Text fontSize="xs" color="gray.600" mt={1}>
									When enabled, all users will be prompted to set up two-factor authentication on their first login.
								</Text>
							</Box>
							<Switch
								isChecked={globalRequire2FA}
								onChange={(e) => handleGlobal2FAToggle(e.target.checked)}
								sx={{
									'& .chakra-switch__track': {
										bg: 'gray.300',
									},
									'& .chakra-switch__track[data-checked]': {
										bg: 'var(--brand-primary)',
									},
								}}
								size="md"
							/>
						</Flex>
					</CardBody>
				</Card>

				{/* Main Card */}
				<Card
					bg="white"
					shadow="sm"
					borderRadius="lg"
					border="1px solid"
					borderColor="gray.200"
				>
					{/* Card Header */}
					<Box px={6} py={2} borderBottom="1px solid" borderColor="gray.200">
						<Flex justify="space-between" align="center">
							<Box>
								<Text fontSize="lg" fontWeight="medium">
									Users
								</Text>
								<Text fontSize="sm" color="gray.600">
									Total users: {list.length}
								</Text>
							</Box>

							{createPermission && (
								<CustomModal
									showModalButtonText="Add New User"
									modalHeader="Add New User"
									isOpen={isOpen}
									onClose={onClose}
									onOpen={onOpen}
									modalBody={<Create meClose={meClose} customer_id={customer_id} loadList={loadList} />}
								/>
							)}
						</Flex>
					</Box>

					{/* Card Content */}
					<Box p={6}>
						{listPermission ? (
							<>
								{/* Search Bar */}
								<Box mb={4}>
									<InputGroup size="md">
										<InputLeftElement pointerEvents="none">
											<SearchIcon color="gray.400" />
										</InputLeftElement>
										<Input
											placeholder="Search by name, user ID, or email..."
											value={searchQuery}
											onChange={(e) => setSearchQuery(e.target.value)}
											bg="white"
											border="1px solid"
											borderColor="gray.300"
											_focus={{
												borderColor: 'var(--brand-primary)',
												boxShadow: '0 0 0 1px var(--brand-primary)',
											}}
										/>
									</InputGroup>
								</Box>

								{/* Table */}
								<Box
									border="1px solid"
									borderColor="gray.200"
									borderRadius="lg"
									overflow="hidden"
								>
									<TableContainer>
										<Table variant="simple" size="sm">
											<Thead bg="gray.50">
												<Tr>
													<Th fontSize="xs" fontWeight="semibold" color="gray.600">
														Full Name
													</Th>
													<Th fontSize="xs" fontWeight="semibold" color="gray.600">
														User ID
													</Th>
													<Th fontSize="xs" fontWeight="semibold" color="gray.600">
														Role
													</Th>
													<Th fontSize="xs" fontWeight="semibold" color="gray.600">
														Super Admin
													</Th>
													<Th fontSize="xs" fontWeight="semibold" color="gray.600">
														Status
													</Th>
													<Th fontSize="xs" fontWeight="semibold" color="gray.600">
														2FA Status
													</Th>
													<Th fontSize="xs" fontWeight="semibold" color="gray.600">
														2FA Required
													</Th>
													<Th fontSize="xs" fontWeight="semibold" color="gray.600">
														Account Alert
													</Th>
													<Th fontSize="xs" fontWeight="semibold" color="gray.600">
														Actions
													</Th>
												</Tr>
											</Thead>

											<Tbody>
												{loading ? (
													// Loading spinner in center of table
													<Tr>
														<Td colSpan={9} py={12}>
															<Center>
																<Spinner size="xl" color="blue.500" thickness="4px" />
															</Center>
														</Td>
													</Tr>
												) : (
													filteredUsers.map((rs, index) => (
														<Tr
															key={index || rs?.id}
															_hover={{ bg: 'transparent' }}
															borderBottom="1px solid"
															borderColor="gray.100"
														>
															<Td fontSize="sm" fontWeight="medium" color="gray.900">
																{rs.username}
															</Td>
															<Td fontSize="sm" color="gray.600">
																{rs.email}
															</Td>
															<Td>
																<Tag
																	size="sm"
																	bg="var(--brand-100)"
																	color="var(--brand-800)"
																>
																	{getRoleName(rs.role_id)}
																</Tag>
															</Td>
															<Td>
																<HStack spacing={2}>
																	<Switch
																		isChecked={rs.super_admin}
																		onChange={() => handleTogglesuperAdmin(rs)}
																		isDisabled={loadingStates[`superadmin_${rs.id}`]}
																		sx={{
																			'& .chakra-switch__track': {
																				bg: 'gray.300',
																			},
																			'& .chakra-switch__track[data-checked]': {
																				bg: 'var(--brand-primary)',
																			},
																		}}
																		size="sm"
																	/>
																	{loadingStates[`superadmin_${rs.id}`] && (
																		<Spinner size="xs" color="blue.500" />
																	)}
																</HStack>
															</Td>
															<Td>
																<Flex align="center" gap={2}>
																	<Switch
																		isDisabled={!StatusPermission || loadingStates[`status_${rs.id}`]}
																		isChecked={rs.status_id === 1}
																		onChange={() => ChangeStatus(rs)}
																		sx={{
																			'& .chakra-switch__track': {
																				bg: 'gray.300',
																			},
																			'& .chakra-switch__track[data-checked]': {
																				bg: 'var(--brand-primary)',
																			},
																		}}
																		size="sm"
																	/>
																	<Text fontSize="sm" color="gray.700">
																		{rs.status_id === 1 ? 'Active' : 'Inactive'}
																	</Text>
																	{loadingStates[`status_${rs.id}`] && (
																		<Spinner size="xs" color="blue.500" />
																	)}
																</Flex>
															</Td>
															<Td>
																<Flex align="center" gap={2}>
																	{rs.twofa_enabled === 1 ? (
																		<Text fontSize="sm" color="#00a63e">
																			Enabled
																		</Text>
																	) : (
																		<Text fontSize="sm" color="#ff6900">
																			Not Enabled
																		</Text>
																	)}
																</Flex>
															</Td>
															<Td>
																<Flex align="center" gap={2}>
																	<Switch
																		isChecked={rs.twofa_required}
																		onChange={() => handleToggle2FARequired(rs)}
																		isDisabled={loadingStates[`2fa_${rs.id}`]}
																		sx={{
																			'& .chakra-switch__track': {
																				bg: 'gray.300',
																			},
																			'& .chakra-switch__track[data-checked]': {
																				bg: 'var(--brand-primary)',
																			},
																		}}
																		size="sm"
																	/>
																	<Text fontSize="sm" color="gray.700">
																		{rs.twofa_required ? 'Required' : 'Optional'}
																	</Text>
																	{loadingStates[`2fa_${rs.id}`] && (
																		<Spinner size="xs" color="blue.500" />
																	)}
																</Flex>
															</Td>
															<Td>
																<Flex align="center" gap={2}>
																	<Switch
																		isChecked={!!rs.account_alert}
																		onChange={() => handleAccountAlertToggle(rs)}
																		isDisabled={loadingStates[`accountalert_${rs.id}`]}
																		sx={{
																			'& .chakra-switch__track': {
																				bg: 'gray.300',
																			},
																			'& .chakra-switch__track[data-checked]': {
																				bg: 'var(--brand-primary)',
																			},
																		}}
																		size="sm"
																	/>
																	<Text fontSize="sm" color="gray.700">
																		{rs.account_alert ? 'Enabled' : 'Disabled'}
																	</Text>
																	{loadingStates[`accountalert_${rs.id}`] && (
																		<Spinner size="xs" color="blue.500" />
																	)}
																</Flex>
															</Td>
															<Td>
																<Flex align="center" gap={2}>
																	{changePassPermission && (
																		<Text
																			variant="ghost"
																			size="sm"
																			fontSize="xs"
																			color="var(--brand-primary)"
																			cursor={"pointer"}
																			onClick={() => meChangePass(rs)}
																		>
																			Change Password
																		</Text>
																	)}
																	{editPermission && (
																		<IconButton
																			icon={<EditIcon />}
																			variant="ghost"
																			size="sm"
																			aria-label="Edit user"
																			_hover={{ bg: 'gray.50' }}
																			onClick={() => meEdit(rs)}
																		/>
																	)}
																</Flex>
															</Td>
														</Tr>
													))
												)}
											</Tbody>
										</Table>
									</TableContainer>

									{!loading && filteredUsers.length === 0 && (
										<Box py={8} textAlign="center">
											<Text color="gray.500" fontSize="sm">
												No users found matching your search criteria
											</Text>
										</Box>
									)}
								</Box>
							</>
						) : (
							<Center h="400px">
								<Box textAlign="center">
									<Text fontSize="xl" fontWeight="semibold" color="gray.700" mb={2}>
										No Access
									</Text>
									<Text fontSize="sm" color="gray.500">
										You don't have permission to view this section.
									</Text>
								</Box>
							</Center>
						)}
					</Box>
				</Card>

			</BoxWrapper>

			<CustomModalLink
				showModalButtonText={modalHeader}
				modalHeader={modalHeader}
				isOpenEdit={isOpenEdit}
				onCloseEdit={meCloseEdit}
				onOpenEdit={onOpenEdit}
				modalBody={modalEditView}
			/>
		</>
	);
}

export default List;